import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateCartonComponent } from '../create-carton/create-carton.component';
import { type } from 'os';

@Component({
  selector: 'app-carton-steps',
  templateUrl: './carton-steps.component.html',
  styleUrls: ['./carton-steps.component.scss']
})
export class CartonStepsComponent implements OnInit {
  type2CompaignCreate= true;
  rewardBifurcation = false;
  type2Whitelist = false;
  communicationMatrix = false;
  localDetail : any = {}
  type:any =''
  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden
  };

  type2config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    toolbarSettings: {
      toolbarExtraButtons: [
        // { text: 'Finish', class: 'btn btn-info', event: () => { alert("Finished!!!"); } }
      ],
    }
  };
  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.ngWizardService.next();
  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  stepChanged(args: StepChangedArgs) {
    console.log(args.step);
  }

  isValidTypeBoolean: boolean = true;

  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;
  }

  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    return of(true);
  }
  carton_type:any = 1;
  cartonType(e){
    this.carton_type =e;
    console.log("hellleelel",e);
  }
  cartonType2(e){
    this.carton_type = e;
  }
  editCartonType(e){
    console.log("edit",e)
  }














  createCartonFlag = true;
  cartontype:any = 1;
  typeFlag:boolean
  whiteListFlag = true
  pointConfigrationFlag = false
  targetFlag = false
  specialOccasionFlag = false
  id : any = "";
  // stepStates = {
  //   normal: STEP_STATE.normal,
  //   disabled: STEP_STATE.disabled,
  //   error: STEP_STATE.error,
  //   hidden: STEP_STATE.hidden
  // };

  config: NgWizardConfig = {
    selected: 0, //default selected value
    theme: THEME.arrows,
    toolbarSettings: {}
  };
  is_caplimt : any = "0";
  cartonId : any = "";

  constructor(
    private ngWizardService: NgWizardService,
    private router : Router,
    private activatedRoute: ActivatedRoute) {
      this.getId();
    //  console.log("3456789",this.router.getCurrentNavigation().extras.state.example);
    }
    getId(){
      this.id =  this.activatedRoute.snapshot.paramMap.get("id")
      this.type = this.activatedRoute.snapshot.paramMap.get("type")
      console.log("type ",this.activatedRoute.snapshot.paramMap.get("type"))

      if(this.id == 0){
        this.cartonId = localStorage.getItem("campaign_id");
      }else{
        this.cartonId =  this.activatedRoute.snapshot.paramMap.get("cartonid")
      }
      console.log("cartonid",this.cartonId)


     console.log(this.id)
    }
  ngOnInit() {
    this.carton_type =this.activatedRoute.snapshot.paramMap.get("type")
    this.localDetail = JSON.parse(localStorage.getItem('cartonFlgs'))
      console.log("localstorage",this.localDetail)
        this.cartonSetps();
  }
  // ngDoCheck(){
  //   this.cartonSetps()
  // }

  cartonSetps(){
    this.createCartonFlag = true;
    this.type2CompaignCreate = true;
    // {
    //   if(localStorage.getItem('whiteListFlag') == "true"){
    //     this.whiteListFlag = true
    //     this.whiteListData(true)
    //   }else{
    //     this.whiteListFlag = false
    //   }
    //   if(localStorage.getItem('pointConfigrationFlag') == "true"){
    //     this.pointConfigrationFlag = true
    //     this.pointConfigration(true)
    //   }else{
    //     this.pointConfigrationFlag = false
    //   }
    //   if(localStorage.getItem('targetFlag') == "true"){
    //     this.targetFlag = true
    //     this.target(true)
    //   }else{
    //     this.targetFlag = false
    //   }
    //   if(localStorage.getItem('specialOccasionFlag') == "true"){
    //     this.specialOccasionFlag = true
    //     this.specialOccasion(true);
    //   }else{
    //     this.specialOccasionFlag = false
    //   }
    // }
debugger
    if (this.type == 1) {
      debugger
      console.log('steps  ')
      this.createCartonFlag = true;
      // {
      //   if (localStorage.getItem('whiteListFlag') == "true") {
      //     this.whiteListFlag = true
      //     this.whiteListData(true)
      //   } else {
      //     this.whiteListFlag = false
      //   }
      //   if (localStorage.getItem('pointConfigrationFlag') == "true") {
      //     this.pointConfigrationFlag = true
      //     this.pointConfigration(true)
      //   } else {
      //     this.pointConfigrationFlag = false
      //   }
      //   if (localStorage.getItem('targetFlag') == "true") {
      //     this.targetFlag = true
      //     this.target(true)
      //   } else {
      //     this.targetFlag = false
      //   }
      //   if (localStorage.getItem('specialOccasionFlag') == "true") {
      //     this.specialOccasionFlag = true
      //     this.specialOccasion(true);
      //   } else {
      //     this.specialOccasionFlag = false
      //   }
      // }
      console.log("flagssss",this.localDetail)
      debugger
      if (this.localDetail.type1whiteList == true) {
        this.whiteListFlag = true
        this.whiteListData(true)
      } else {
        this.whiteListFlag = false
      }
      if (this.localDetail.pointConfigrationFlag == true) {
        this.pointConfigrationFlag = true
        this.pointConfigration(true)
      } else {
        this.pointConfigrationFlag = false
      }
      if (this.localDetail.targetFlag == true) {
        this.targetFlag = true
        this.target(true)
      } else {
        this.targetFlag = false
      }
      if (this.localDetail.specialOccasionFlag == true) {
        this.specialOccasionFlag = true
        this.specialOccasion(true);
      } else {
        this.specialOccasionFlag = false
      }
    }
    else if(this.type == 2){
      this.type2CompaignCreate = true;
      if (this.localDetail.rewardBifurcation == true) {
        this.rewardBifurcation = true
        this.rewardBifur(true)
      } else {
        this.rewardBifurcation = false
      }
      if (this.localDetail.whiteListFlag == true) {
        this.type2Whitelist = true
        this.type2whiteListData(true)
      } else {
        this.type2Whitelist = false
      }
      if (this.localDetail.communicationMatrix == true) {
        this.communicationMatrix = true
        this.comm_matrix(true)
      } else {
        this.communicationMatrix = false
      }

    }


  }

  createCartonData(e){
    // debugger
    console.log(e)
    this.whiteListFlag = e;
    if(this.whiteListFlag == true && this.is_caplimt != undefined){
      setTimeout(()=>{
        this.ngWizardService.next();
      },500)
    }
  }
  whiteListData(event){
    console.log("@#$%",event)
    this.pointConfigrationFlag = event
    if(this.pointConfigrationFlag){
      setTimeout(()=>{
        this.ngWizardService.next();
      },100)
    }
  }
  pointConfigration(e){
    console.log(e)
    this.targetFlag = e
    if(this.targetFlag){
      setTimeout(()=>{
        this.ngWizardService.next();
      },100)
    }
  }
  target(e){
    console.log(e)
    this.specialOccasionFlag = e;
    if(this.specialOccasionFlag){
      setTimeout(()=>{
        this.ngWizardService.next();
      },100)
    }

  }
  specialOccasion(e){
    console.log(e)
    // this.router.navigateByUrl("/hubAdmin/carton-list")
    setTimeout(()=>{
      this.ngWizardService.next();
    },100)
  }
  caplimit(e){
    // debugger
    console.log(e)
    this.is_caplimt = e;
  }
  campaignID(e){
    this.cartonId = e;
    console.log("campaignID",e)
  }
  selectType(e){
    if(e==1){
      this.typeFlag = true;
      this.cartonSetps();
      this.getId()
    }else{
      this.typeFlag = false;
      this.cartonSetps();
      this.getId()
    }

  }
  type2CreateCartonData(e){
    // debugger
    console.log(e)
    this.rewardBifurcation = true
    setTimeout(()=>{
      this.ngWizardService.next();
    },100)
  }
  rewardBifur(e){
    console.log("sfdkjdskf")
    this.type2Whitelist = e;
    if(this.type2Whitelist == true ){
      setTimeout(()=>{
        this.ngWizardService.next();
      },500)
    }

  }
  type2whiteListData(event){
    console.log("@#$%",event)
    this.communicationMatrix = event
    if(this.communicationMatrix){
      setTimeout(()=>{
        this.ngWizardService.next();
      },100)
    }
  }
  comm_matrix(e){
    this.communicationMatrix = true
    setTimeout(()=>{
      this.ngWizardService.next();
    },100)
  }

}
